/**
 * External dependencies
 */
import React from 'react'

/**
 * Internal dependencies
 */

// This is intentionally a Component class, not a function component because it
// is common to apply a ref to the button element (only supported in class)
class DisableLinkClick extends React.Component {
	constructor( props ) {
		super( props )
		this.onUnload = this.onUnload.bind( this );
	}
	safeToLoadClickedPage = () => {
		const { isSaving, inspectorActive, codeChanged } = this.props

		// if ( ! inspectorActive && ! isSaving && ! codeChanged ) {
		if ( ! isSaving && ! codeChanged ) {
			return true
		}

		return false
	}

	isInspectorActive = () => {
		const { inspectorActive } = this.props

		if ( this.props.inspectorActive ) {
			return true
		}

		return false
	}

	onUnload( event ) {
		// Propmt users about unsaved data only if they really have unsaved data,
		// otherwise let my people go.
		if ( ! this.safeToLoadClickedPage() ) {
			// Prompt the user with warning.
			// https://developer.mozilla.org/en-US/docs/Web/Events/beforeunload
			event.returnValue = "❌"
			return "❌"
		}
		// Save to load new page.
	}

	componentDidMount = () => {
		// Before leaving the page check if we have any unsaved data.
		window.addEventListener( "beforeunload", this.onUnload )
		// Get all links from the iFrame.
		const iframeLinks = window.Stylist.iDoc.querySelectorAll( 'a[href]' )
		// For every link in iFrame add click listener.
		// @todo: can we optimize it?
		Array.from( iframeLinks ).forEach( link => {
			link.addEventListener( 'click', event => {
				// Always open links in a parent frame.
				link.setAttribute( "target", "_top" );

				// Allow link clock if DOM selector isn't active.
				if ( this.isInspectorActive() ) {
					// Can't go ahead as element inspector is active.
					event.preventDefault();
					// const href = link.getAttribute( "href" );
				}
				// Proceed loading new page in the parent frame.
			} )
		} )
	}
	render() {
		return <div></div>;
	}
}

export default DisableLinkClick;



// WEBPACK FOOTER //
// ./dev/stylist_parent/components/disable-link-click/index.js